<template>
  <div class="rain-live" v-if="rainImageResult.picpath">
    <div class="publish-time" v-show="rainImageResult.time">
<!--      <i class="el-icon-time"></i>-->
<!--      数据时间：{{ $moment(Number(rainImageResult.time)).format('YYYY-MM-DD HH:mm') }}-->
      <div>{{ $moment(Number(rainImageResult.time)).format('YYYY-MM-DD HH:mm') }}更新</div>
    </div>
    <div class="image">
      <el-image :src="base_url + rainImageResult.picpath" :preview-src-list="[`${base_url}${rainImageResult.picpath}`]">
      </el-image>
    </div>
    <div class="text">{{ rainImageResult.maxstr }}</div>
  </div>
</template>

<script>
import { number } from 'echarts/core'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      expand: false,
      base_url: process.env.VUE_APP_DATA + '/rainPic/'
    }
  },
  computed: {
    ...mapState('home', ['rainImageResult'])
  }
}
</script>

<style lang="less" scoped>
.rain-live {
  display: flex;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 3.2vw 1.04vw .5vh;
  box-sizing: border-box;
  height: 100%;
  border-radius: 0.63vw;
  color: #fff;

  .image {
    display: flex;
    justify-content: center;
    width: 50%;
    height: 100%;

    img {
      height: 100%;
      cursor: pointer;
    }
  }

  .text {
    flex: 1;
    line-height: 1.72vw;
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;
    ;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
